import React, { useEffect, useState } from 'react';
import "../utils/Style/component/auto-conversion.scss";

function AutoConversionToggle({ isChecked, handle_toggleChange, convertText, disabled }) {
    const [checkedText, setCheckedText] = useState("Off");
    const [toggleClass, setToggleClass] = useState("toggle-input");

    useEffect(() => {
        setCheckedText(isChecked ? "On" : "Off");
        setToggleClass(isChecked ? "toggle-input checked-toggle" : "toggle-input");
    }, [isChecked]);

    return (
        <div>
            <div className="auto-conversion">
                <div className={disabled ? "card disabled" : "card"}>
                    {/* CHANGED: 'align-items-center' -> 'align-items-start'
                       This aligns the toggle to the top (with the Title) instead of the middle.
                    */}
                    <div className="row align-items-start">
                        
                        {/* Text Section */}
                        <div className="label col-12 col-md-9 mb-3 mb-md-0">
                            <div className="title">Auto-Conversion</div>
                            <div className="desc">{convertText}</div>
                        </div>

                        {/* Toggle Section */}
                        <div className="col-12 col-md-3">
                            {/* ADDED: 'mt-1' to push it down slightly so it aligns 
                               visually with the Title text's center.
                            */}
                            <div className="toggle d-flex align-items-start justify-content-start justify-content-md-end gap-3 mb-2">
                                <div className="toggle-switch">
                                    <div
                                        id="toggle"
                                        className={toggleClass}
                                        onClick={() => {
                                            if (!disabled)
                                                handle_toggleChange();
                                        }}
                                    />
                                    <label htmlFor="toggle" className="toggle-label" />
                                </div>
                                <div className="label mb-0" style={{ minWidth: "30px" }}>
                                    {checkedText}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default AutoConversionToggle;